import { render, staticRenderFns } from "./reportDialog.vue?vue&type=template&id=168976fc&scoped=true"
import script from "./reportDialog.vue?vue&type=script&lang=js"
export * from "./reportDialog.vue?vue&type=script&lang=js"
import style0 from "./reportDialog.vue?vue&type=style&index=0&id=168976fc&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168976fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('168976fc')) {
      api.createRecord('168976fc', component.options)
    } else {
      api.reload('168976fc', component.options)
    }
    module.hot.accept("./reportDialog.vue?vue&type=template&id=168976fc&scoped=true", function () {
      api.rerender('168976fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/consultation/reportDialog.vue"
export default component.exports